module.exports = __webpack_public_path__ + "static/media/img1-tc-mobile.33bce027.png";